import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-overview',
  templateUrl: './icon-overview.component.html',
  styles: []
})
export class IconOverviewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
